<div class="modal-overlay" *ngIf="showModal">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div>
        <h2>Update Appointment Fees</h2>
        <p class="appointment-info" *ngIf="appointment">
          Appointment: {{ appointment.customerName }} - {{ appointment.date | date: 'dd/MM/yyyy' }} (ID: {{ appointment.appointmentId }})
        </p>
        <p class="help-text-header">
          <i class="fas fa-info-circle"></i> Use this to assign collection charge and platform fees to appointments in special cases.
        </p>
      </div>
      <button class="close-btn" (click)="onCancel()" type="button">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="modal-body">
      <!-- Display existing fees if they exist -->
      <div class="existing-fees-section" *ngIf="appointment && (appointment.collectionCharge !== null && appointment.collectionCharge !== undefined || appointment.platformChargeInPercent !== null && appointment.platformChargeInPercent !== undefined)">
        <h3 class="existing-fees-title">
          <i class="fas fa-info-circle"></i> Current Fees
        </h3>
        <div class="existing-fees-grid">
          <div class="existing-fee-item" *ngIf="appointment.collectionCharge !== null && appointment.collectionCharge !== undefined">
            <span class="fee-label">Collection Charge:</span>
            <span class="fee-value">{{ appointment.collectionCharge | number:'1.2-2' }}</span>
            <span class="fee-source" *ngIf="appointment.collectionChargeSource">
              <i class="fas fa-info-circle"></i> Source: {{ appointment.collectionChargeSource }}
            </span>
          </div>
          <div class="existing-fee-item" *ngIf="appointment.platformChargeInPercent !== null && appointment.platformChargeInPercent !== undefined">
            <span class="fee-label">Platform Fee:</span>
            <span class="fee-value">{{ appointment.platformChargeInPercent | number:'1.2-2' }}%</span>
            <span class="fee-source" *ngIf="appointment.platformChargeSource">
              <i class="fas fa-info-circle"></i> Source: {{ appointment.platformChargeSource }}
            </span>
          </div>
        </div>
      </div>

      <form [formGroup]="feesForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label for="collectionCharge">
            Collection Charge
            <span class="optional-label">(Optional)</span>
          </label>
          <input 
            type="number" 
            id="collectionCharge"
            formControlName="collectionCharge"
            placeholder="Enter collection charge amount"
            class="form-control"
            step="0.01"
            min="0"
            [class.invalid]="feesForm.get('collectionCharge')?.invalid && feesForm.get('collectionCharge')?.touched">
          <div class="error-message" *ngIf="feesForm.get('collectionCharge')?.invalid && feesForm.get('collectionCharge')?.touched">
            <span *ngIf="feesForm.get('collectionCharge')?.errors?.['min']">Collection charge must be 0 or greater</span>
          </div>
          <small class="help-text">Leave empty to use default collection charge</small>
        </div>

        <div class="form-group">
          <label for="platformFeeInPercentage">
            Platform Fee (Percentage)
            <span class="optional-label">(Optional)</span>
          </label>
          <input 
            type="number" 
            id="platformFeeInPercentage"
            formControlName="platformFeeInPercentage"
            placeholder="Enter platform fee percentage (0-100)"
            class="form-control"
            step="0.01"
            min="0"
            max="100"
            [class.invalid]="feesForm.get('platformFeeInPercentage')?.invalid && feesForm.get('platformFeeInPercentage')?.touched">
          <div class="error-message" *ngIf="feesForm.get('platformFeeInPercentage')?.invalid && feesForm.get('platformFeeInPercentage')?.touched">
            <span *ngIf="feesForm.get('platformFeeInPercentage')?.errors?.['min']">Platform fee must be 0 or greater</span>
            <span *ngIf="feesForm.get('platformFeeInPercentage')?.errors?.['max']">Platform fee cannot exceed 100%</span>
          </div>
          <small class="help-text">Leave empty to use default platform fee percentage</small>
        </div>

        <div class="error-message global-error" *ngIf="errorMessage">
          {{ errorMessage }}
        </div>

        <div class="modal-actions">
          <button 
            type="button" 
            class="btn btn-secondary" 
            (click)="onCancel()"
            [disabled]="isLoading">
            Cancel
          </button>
          <button 
            type="submit" 
            class="btn btn-primary" 
            [disabled]="feesForm.invalid || isLoading">
            <span *ngIf="isLoading" class="loading-spinner"></span>
            {{ isLoading ? 'Updating...' : 'Update Fees' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

